import MUIFormLabel from '@mui/material/FormLabel';
import type { SxProps } from '@mui/material/styles';
import type { ReactNode } from 'react';

import GenericTooltip from '~/common/components/GenericTooltip';

type FormLabelProps = {
  label: ReactNode;
  tooltip?: string;
  required?: boolean;
  htmlFor?: string;
  variant?: 'small';
  disabled?: boolean;
  sx?: SxProps;
};

const FormLabel = ({
  label,
  tooltip,
  required,
  htmlFor,
  variant,
  disabled = false,
  sx,
}: Readonly<FormLabelProps>) => {
  return (
    <MUIFormLabel
      required={required}
      htmlFor={htmlFor}
      disabled={disabled}
      sx={variant === 'small' ? { fontSize: '0.875rem', ...sx } : sx}
    >
      {label}
      {!!tooltip && <GenericTooltip label={tooltip} />}
    </MUIFormLabel>
  );
};

export default FormLabel;
